import { render, staticRenderFns } from "./LayerForm.vue?vue&type=template&id=1bafb04e&"
import script from "./LayerForm.vue?vue&type=script&lang=js&"
export * from "./LayerForm.vue?vue&type=script&lang=js&"
import style0 from "./LayerForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports